const CheckIcon = (props: any) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox='0 0 16 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4 8.2479L6.65511 10.6335L12 5.8335'
      stroke='#1FA238'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default CheckIcon;
